import Publishable from '@/components/toolbox/immoscout/Publishable'
import Published from '@/components/toolbox/immoscout/Published'
import immoscout from '@/api/immoscout'
import GeoObject from '@/models/GeoObject'
import Vue from 'vue'

class ImmoScoutSync {
  constructor () {
    this.loaded = false
    this.objects = []
    this.publishedObjects = []
    this.limitsByCategory = {}
    this.currentObjectsByCategory = {}
    this.loadingPromise = this.init()
  }

  async init () {
    let allObjects = await immoscout.getList()

    this.objects = []
    this.publishedObjects = []
    for (let i = 0; i < allObjects.data.length; i++) {
      allObjects.data[i].loaded = true
      if (allObjects.data[i].isPublishedToImmoscout) {
        this.publishedObjects.push(new GeoObject(allObjects.data[i]))
        continue
      }
      this.objects.push(new GeoObject(allObjects.data[i]))
    }

    Vue.set(this, 'limitsByCategory', allObjects.limits)
    this.refreshLimits()
    this.loaded = true
  }

  refreshObjects () {
    this.init()
  }

  refreshLimits () {
    this.currentObjectsByCategory = {}
    for (let i = 0; i < this.objects.length; i++) {
      if (typeof this.currentObjectsByCategory[this.objects[i].field_objectRights.value] === 'undefined') {
        this.currentObjectsByCategory[this.objects[i].field_objectRights.value] = 0
      }
      this.currentObjectsByCategory[this.objects[i].field_objectRights.value]++
    }

    for (let i = 0; i < this.publishedObjects.length; i++) {
      if (typeof this.currentObjectsByCategory[this.publishedObjects[i].field_objectRights.value] === 'undefined') {
        this.currentObjectsByCategory[this.publishedObjects[i].field_objectRights.value] = 0
      }
      this.currentObjectsByCategory[this.publishedObjects[i].field_objectRights.value]++
    }
  }

  getToolboxTabs () {
    return {
      'Zu Veröffentlichen': {
        tab: Publishable,
        icon: 'edit'
      },
      'Veröffentlicht': {
        tab: Published,
        icon: 'edit'
      }
    }
  }
}

export default ImmoScoutSync
